import { alpha, Components, CssVarsTheme } from '@mui/material/styles';

export const MuiMenuItem: Components<CssVarsTheme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 400,
      padding: '0.5rem',
      borderRadius: 6,
      minHeight: 'unset',
      color: theme.vars.palette.neutral.dark,
      '&:not(:last-of-type)': {
        marginBottom: 4
      },
      '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.light, 0.16),
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.light, 0.08)
        }
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: alpha(theme.palette.primary.light, 0.16),
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.light, 0.08)
        }
      },
      '&+.MuiDivider-root': {
        margin: '4px 0px'
      }
    })
  }
};

export const MuiPopover: Components<CssVarsTheme>['MuiPopover'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      backdropFilter: 'blur(20px)',
      backgroundColor: alpha('#fff', 0.5),
      padding: '4px',
      marginTop: '8px',
      boxShadow: theme.vars.customShadow.secondary.center,
      borderRadius: '8px',
      '& .MuiList-root': {
        paddingTop: 0,
        paddingBottom: 0
      }
    })
  }
};
